import { generateRedirectUrl } from '@domain-group/javascript-utils'
import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useOrderBundle from '@hooks/useOrderBundle'

import { OrderBundleModel } from '@domain-group/realhub-backend-api-types'

const OrderBundleListItem = (props: {orderBundleListItem: OrderBundleModel}) => {
  const { orderBundleListItem } = props

  const { price, title } = orderBundleListItem || {}

  const {
    // @ts-expect-error TS2339
    urls: { editOrderBundleUrl },
  } = useOrderBundle(orderBundleListItem)

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        ${price}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon href={`${editOrderBundleUrl}?redirect=${generateRedirectUrl()}`} type="link" />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}
export default OrderBundleListItem
